import { render, staticRenderFns } from "./DetailQuotation.vue?vue&type=template&id=64d661cd&scoped=true&"
import script from "./DetailQuotation.vue?vue&type=script&lang=js&"
export * from "./DetailQuotation.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuotation.vue?vue&type=style&index=0&id=64d661cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d661cd",
  null
  
)

export default component.exports